import { useEffect, useState } from "react";

const NAV_LINKS = [
  { label: "排行榜", href: "#ranking" },
  { label: "豆瓣高分", href: "#douban" },
  { label: "类型片", href: "#genre" },
  { label: "动作片", href: "#action" },
  { label: "爱情片", href: "#romance" },
  { label: "恐怖片", href: "#horror" },
  { label: "关于榜单", href: "#guide" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full transition-colors duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/95 border-b border-background-200 backdrop-blur"
          : "bg-transparent"
      }`}
    >
      <div className="flex h-16 items-center justify-between px-4 md:px-8">
        <a
          href="#top"
          className={`flex items-center gap-2 whitespace-nowrap ${
            scrolled || menuOpen ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-movie-2-line text-lg" />
          </span>
          <span className="font-heading text-lg font-bold tracking-wide">九七电影院</span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`rounded-md px-3 py-2 text-sm whitespace-nowrap transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
                  : "text-background-100 hover:bg-background-50/20 hover:text-background-50"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#ranking"
            className={`hidden whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors md:flex ${
              scrolled
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50 text-foreground-950 hover:bg-background-100"
            }`}
          >
            看本期榜单
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`flex h-10 w-10 items-center justify-center rounded-md lg:hidden ${
              scrolled || menuOpen ? "text-foreground-950" : "text-background-50"
            }`}
          >
            <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav className="flex flex-col gap-1 border-t border-background-200 px-4 pb-4 pt-2 lg:hidden">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="rounded-md px-3 py-2 text-sm text-foreground-800 hover:bg-primary-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}